// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array } from 'prop-types'
import { connect } from 'react-redux'
import Notifications from 'react-notification-system-redux'

const ReduxNotifications = ({ notifications }) => (
  <Notifications notifications={notifications} />
)

ReduxNotifications.propTypes = {
  notifications: array.isRequired,
}

const mapStateToProps = ({ notifications }) => ({ notifications })

export default connect(mapStateToProps)(ReduxNotifications)
